/**
 * Bảng tính soạn được trong app — APM-XLE-a, docs/plan-sheet-editor.md §5.
 *
 * Khác `DocumentFormat` (`text | markdown | chilldoc`) — đó là của hộp soạn
 * **chữ** (nháp, `?new=`, nhóm nút). Bảng tính là một loại hộp soạn khác (Univer),
 * chọn theo đuôi ở nơi mở. Hai bên chỉ gặp nhau ở `isEditableFileName`: một
 * nguồn sự thật cho `canEdit` (API) và cho trang Tệp.
 */
export const SHEET_EXTENSIONS = ['.xlsx', '.xls'];
/** Lưu luôn ghi `.xlsx` — không thư viện mã nguồn mở nào ghi được `.xls` (BIFF8). */
export const SHEET_SAVE_EXTENSION = '.xlsx';
export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export function isSheetDocumentName(filename) {
    const lower = filename.toLowerCase();
    return SHEET_EXTENSIONS.some((extension) => lower.endsWith(extension));
}
/** Tên tệp sau khi lưu từ hộp soạn bảng tính: `.xls` đổi thành `.xlsx`, còn lại giữ nguyên. */
export function sheetSaveName(filename) {
    return filename.toLowerCase().endsWith('.xls')
        ? filename.slice(0, -'.xls'.length) + SHEET_SAVE_EXTENSION
        : filename;
}
// `isEditableFileName` và `sameEditableFamily` ở `office-document.ts` (gộp cả Word/PowerPoint, APM-WDE-a).
//# sourceMappingURL=sheet-document.js.map